export const GLOBAL_ERROR_CODE = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  NO_PERMISSION: 'NO_PERMISSION',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
};

export const BED_STATUS = {
  AVAILABLE: 'AVAILABLE',
  BOOKED: 'BOOKED',
  BLOCKED: 'BLOCKED',
  HELD: 'HELD',
  MAINTENANCE: 'MAINTENANCE',
  NOMINATED: 'NOMINATED',
  OCCUPIED: 'OCCUPIED',
  PENDING: 'PENDING',
  TURNAROUND: 'TURNAROUND',
  UNAVAILABLE: 'UNAVAILABLE',
  RESERVED: 'RESERVED',
  HIDDEN: 'HIDDEN',
};

export const BED_STATUS_INFO_EXPIRATION = {
  ACTIVE: 'ACTIVE',
  HISTORY: 'HISTORY',
};

export const AREA_UNIT_OF_MEASUREMENT = {
  SQM: 'SQM',
  SQFT: 'SQFT',
};

export const LENGTH_UNIT_OF_MEASUREMENT = {
  CM: 'CM',
  INCH: 'INCH',
};

export const GENDER_PREFERENCE = {
  CO_ED: 'CO_ED',
  MALE_ONLY: 'MALE_ONLY',
  FEMALE_ONLY: 'FEMALE_ONLY',
};

export const DIETARY_PREFERENCE = {
  NOT_SPECIFIC: 'NOT_SPECIFIC',
  VEGETARIAN: 'VEGETARIAN',
};

export const SMOKING_PREFERENCE = {
  NOT_SPECIFIC: 'NOT_SPECIFIC',
  PERMITTED: 'PERMITTED',
  NOT_PERMITTED: 'NOT_PERMITTED',
};

export const PET_PREFERENCE = {
  NOT_SPECIFIC: 'NOT_SPECIFIC',
  PERMITTED: 'PERMITTED',
  NOT_PERMITTED: 'NOT_PERMITTED',
};

export const DISABILITY_ACCESS = {
  YES: 'YES',
  NO: 'NO',
};

export const BATHROOM_ARRANGEMENT = {
  NULL: 'NULL',
  PRIVATE: 'PRIVATE',
  SHARED: 'SHARED',
};

export const KITCHEN_ARRANGEMENT = {
  NULL: 'NULL',
  PRIVATE: 'PRIVATE',
  SHARED: 'SHARED',
};

export const ROOM_GROUP_TYPE = {
  CUSTOMIZED: 'CUSTOMIZED',
  DEFAULT: 'DEFAULT',
};

export const FLAT_ARRANGEMENT = {
  SUITE: 'SUITE',
  APARTMENT: 'APARTMENT',
  CLUSTER: 'CLUSTER',
  HOTEL_STYLE: 'HOTEL_STYLE',
  MIXED_CLUSTER: 'MIXED_CLUSTER',
  STUDIO: 'STUDIO',
};

export const ROOM_ARRANGEMENT = {
  STUDIO: 'STUDIO',
  ENSUITE: 'ENSUITE',
  CLUSTER: 'CLUSTER',
  DORM: 'DORM',
  TWIN: 'TWIN',
  TRIPLE: 'TRIPLE',
  BUNK: 'BUNK',
};

export const BATHROOM_TYPE = {
  HALF_BATH: 'HALF_BATH',
  THREE_QUARTERS_BATH: 'THREE_QUARTERS_BATH',
  FULL_BATH: 'FULL_BATH',
};

export const KITCHEN_TYPE = {
  ELECTRIC: 'ELECTRIC',
  GAS: 'GAS',
  KITCHENETTE: 'KITCHENETTE',
};

export const BILLING_CYCLE = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

export const CURRENCY = {
  GBP: 'GBP',
  AED: 'AED',
  AUD: 'AUD',
  CNY: 'CNY',
  EUR: 'EUR',
  USD: 'USD',
};

export const PROPERTY_TYPE = {
  STUDENT_ACCOMMODATION: 'STUDENT_ACCOMMODATION',
  HOTEL: 'HOTEL',
  SERVICED_APARTMENT: 'SERVICED_APARTMENT',
  REAL_ESTATE: 'REAL_ESTATE',
  LONG_TAIL: 'LONG_TAIL',
};

export const OPERATIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  READ: 'READ',
  DELETE: 'DELETE',
};

export const ROOM_CATEGORY = {
  PRIVATE_ROOM: 'PRIVATE_ROOM',
  SHARED_ROOM: 'SHARED_ROOM',
  ENTIRE_PLACE: 'ENTIRE_PLACE',
};

export const ADDITIONAL_FEE_AMOUNT_TYPE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  FIXED_NIGHTS: 'FIXED_NIGHTS',
  FIXED_MONTHS: 'FIXED_MONTHS',
  PERCENTAGE_OF_RENT: 'PERCENTAGE_OF_RENT',
};

export const ADDITIONAL_FEE_FEATURE = {
  REFUNDABLE: 'REFUNDABLE',
  PART_OF_RENT: 'PART_OF_RENT',
};

export const TIER_UNIT = {
  NIGHTS: 'NIGHTS',
  MONTHS: 'MONTHS',
  PERCENT: 'PERCENT',
  ROOMS: 'ROOMS',
};
export const TIER_UNIT_TITLE = {
  [TIER_UNIT.NIGHTS]: 'nights',
  [TIER_UNIT.MONTHS]: 'months',
  [TIER_UNIT.PERCENT]: '%',
  [TIER_UNIT.ROOMS]: 'rooms',
};

export const OCCUPANCY_SCOPE = {
  ALL_BEDS: 'ALL_BEDS',
  EACH_ROOM_TYPE: 'EACH_ROOM_TYPE',
};

export const CURRENCY_SYMBOL = {
  [CURRENCY.GBP]: '£',
  [CURRENCY.AED]: 'د.إ',
  [CURRENCY.AUD]: '$',
  [CURRENCY.CNY]: '¥',
  [CURRENCY.EUR]: '€',
  [CURRENCY.USD]: '$',
};

export const TENANCY_STATUS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  INACTIVE: 'INACTIVE',
};

export const TENANCY_TYPE = {
  FIXED: 'FIXED',
  FLEXIBLE: 'FLEXIBLE',
};

export const TENANCY_RATE_TYPE = {
  NIGHTLY: 'NIGHTLY',
  MONTHLY: 'MONTHLY',
};

export const TENANCY_START_DATE_TYPE = {
  EQ: 'EQ',
  GE: 'GE',
};

export const TENANCY_END_DATE_TYPE = {
  EQ: 'EQ',
  LE: 'LE',
};

export const TENANCY_LENGTH_TYPE = {
  EQ: 'EQ',
  GE: 'GE',
  LE: 'LE',
};

export const BEHAVIOR_TYPE = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
};

export const POINT_TYPE = {
  CONTRACT_START_DATE: 'CONTRACT_START_DATE',
  BOOKING_CONFIRMED_DATE: 'BOOKING_CONFIRMED_DATE',
};

export const BOOKING_STATUS = {
  ENQUIRY: 'ENQUIRY',
  APPLIED: 'APPLIED',
  ROOM_SELECTED: 'ROOM_SELECTED',
  SELECTION_COMPLETED: 'SELECTION_COMPLETED',
  DETAILS_COMPLETED: 'DETAILS_COMPLETED',
  TERMS_ACCEPTED: 'TERMS_ACCEPTED',
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  BOOKING_COMPLETED: 'BOOKING_COMPLETED',
  RESIDENT: 'RESIDENT',
  PAST: 'PAST',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
};

export const BOOKING_TIPS = {
  AMENDMENT_IN_PROGRESS: 'AMENDMENT_IN_PROGRESS',
  ARRIVAL_INFORMATION_COMPLETED: 'ARRIVAL_INFORMATION_COMPLETED',
  BALANCE_ALLOCATION_AVAILABLE: 'BALANCE_ALLOCATION_AVAILABLE',
  BED_CONFLICT: 'BED_CONFLICT',
  BED_HELD: 'BED_HELD',
  BOOKING_CONFLICT: 'BOOKING_CONFLICT',
  COUNTDOWN_TIMER: 'COUNTDOWN_TIMER',
  CREDIT_REMAINING: 'CREDIT_REMAINING',
  DIRECT_DEBIT_PROCESSING: 'DIRECT_DEBIT_PROCESSING',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  DOCUMENTS_CONFIRMED: 'DOCUMENTS_CONFIRMED',
  DOCUMENTS_MISSING: 'DOCUMENTS_MISSING',
  DOCUMENTS_UPLOADED: 'DOCUMENTS_UPLOADED',
  FORMS_COMPLETED: 'FORMS_COMPLETED',
  FORMS_INCOMPLETE: 'FORMS_INCOMPLETE',
  GENDER_CONFLICT: 'GENDER_CONFLICT',
  IN_ARREARS: 'IN_ARREARS',
  INSPECTION_UNCOMPLETED_CHECK_IN: 'INSPECTION_UNCOMPLETED_CHECK_IN',
  INSPECTION_UNCOMPLETED_CHECK_OUT: 'INSPECTION_UNCOMPLETED_CHECK_OUT',
  NO_ARRIVAL_INFORMATION: 'NO_ARRIVAL_INFORMATION',
  NO_EMERGENCY_CONTACT: 'NO_EMERGENCY_CONTACT',
  OUT_OF_ROOM: 'OUT_OF_ROOM',
  PAYMENT_BEFORE_CHECK_IN_ALL_PAID: 'PAYMENT_BEFORE_CHECK_IN_ALL_PAID',
  PAYMENT_BEFORE_CHECK_IN_UNPAID: 'PAYMENT_BEFORE_CHECK_IN_UNPAID',
  RECURRING_CARD_PAYMENT: 'RECURRING_CARD_PAYMENT',
  REFUNDS_PENDING: 'REFUNDS_PENDING',
  REFUNDS_IN_PROGRESS: 'REFUNDS_IN_PROGRESS',
  SPECIAL_RATE_OFFERED: 'SPECIAL_RATE_OFFERED',
  STAFF_NOTE: 'STAFF_NOTE',
  TASK_OPEN: 'TASK_OPEN',
  UNDER_AGE_RESTRICTION: 'UNDER_AGE_RESTRICTION',
  DUAL_OCCUPANCY: 'DUAL_OCCUPANCY',
};

export const BOOKING_FORMS_STATUS = {
  DISPLAYED: 'DISPLAYED',
  INCOMPLETE: 'INCOMPLETE',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
};

export const BOOKING_FORMS_TYPES = {
  DISPLAY: 'DISPLAY',
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  ACCEPT_OR_REJECT: 'ACCEPT_OR_REJECT',
  CUSTOMIZED_INPUT: 'CUSTOMIZED_INPUT',
};

export const RENTAL_TAXES_RATE_TYPE = {
  INCLUDED: 'INCLUDED',
  EXCLUDED: 'EXCLUDED',
};

export const CONTRACT_STATUS = {
  GENERATED: 'GENERATED',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
};

export const RELATIONSHIP = {
  AUNT: 'AUNT',
  UNCLE: 'UNCLE',
  COUSIN: 'COUSIN',
  FATHER: 'FATHER',
  MOTHER: 'MOTHER',
  GRANDPARENT: 'GRANDPARENT',
  STEP_PARENT: 'STEP_PARENT',
  FRIEND: 'FRIEND',
  WIFE: 'WIFE',
  HUSBAND: 'HUSBAND',
  GUARANTOR: 'GUARANTOR',
  PARTNER: 'PARTNER',
  SPONSOR: 'SPONSOR',
  SIBLING: 'SIBLING',
  TUTOR: 'TUTOR',
  OTHER: 'OTHER',
};

export const DOCUMENT_STATUS = {
  UPLOADED: 'UPLOADED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
};

export const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NEUTRAL: 'NEUTRAL',
  OTHER: 'OTHER',
};

export const BOOKING_CATEGORY = {
  DIRECT_LET: 'DIRECT_LET',
  NOMINATION: 'NOMINATION',
};

export const TAX_RATE_TYPE = {
  FOR_STUDENT: 'FOR_STUDENT',
  FOR_COMMERCIAL: 'FOR_COMMERCIAL',
};

export const TENANCY_LENGTH_OPTION = {
  FIXED_TERM: 'FIXED_TERM',
  ROLLING: 'ROLLING',
};

export const ROLLOVER_REMINDER_UNIT = {
  MONTHS: 'MONTHS',
  NIGHTS: 'NIGHTS',
};

export const EXPIRED_REASON = {
  APPLICATION_TIMEOUT: 'APPLICATION_TIMEOUT',
  ACADEMIC_YEAR_DISABLED: 'ACADEMIC_YEAR_DISABLED',
  TENANCY_OPTION_NOT_FOUND: 'TENANCY_OPTION_NOT_FOUND',
  ROOM_TYPE_NOT_FOUND: 'ROOM_TYPE_NOT_FOUND',
  UNABLE_TO_MAKE_CONTACT: 'UNABLE_TO_MAKE_CONTACT',
  NOT_READY_TO_BOOK: 'NOT_READY_TO_BOOK',
  NOT_A_STUDENT: 'NOT_A_STUDENT',
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  BOOKED_WITH_COMPETITORS_PBSA: 'BOOKED_WITH_COMPETITORS_PBSA',
  BOOKED_WITH_UNIVERSITY_ACCOMMODATION: 'BOOKED_WITH_UNIVERSITY_ACCOMMODATION',
  DECIDED_TO_STUDY_IN_AND_ALTERNATIVE_DESTINATION:
    'DECIDED_TO_STUDY_IN_AND_ALTERNATIVE_DESTINATION',
  DECIDED_NOT_TO_STUDY_NEXT_YEAR: 'DECIDED_NOT_TO_STUDY_NEXT_YEAR',
  REJECTED_BY_THE_GUARANTOR: 'REJECTED_BY_THE_GUARANTOR',
  CHANGE_OF_MIND: 'CHANGE_OF_MIND',
  DUPLICATE_RECORD: 'DUPLICATE_RECORD',
  ALREADY_MADE_A_BOOKING_WITH_US: 'ALREADY_MADE_A_BOOKING_WITH_US',
  TEST_DATA: 'TEST_DATA',
  FAILED_TO_ACCEPT_AMENDMENT: 'FAILED_TO_ACCEPT_AMENDMENT',
  OTHER: 'OTHER',
};

export const YEAR_OF_STUDY_TYPE = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
  FOURTH: 'FOURTH',
  FIFTH: 'FIFTH',
  SIXTH: 'SIXTH',
  SUMMER_COURSE: 'SUMMER_COURSE',
  OTHER: 'OTHER',
};

export const CONTACT_TYPE = {
  EMERGENCY: 'EMERGENCY',
  GUARANTOR: 'GUARANTOR',
};

export const COUNTDOWN_STAGE_OPTION = {
  BEFORE_TERMS_ACCEPTED: 'BEFORE_TERMS_ACCEPTED',
  BEFORE_BOOKING_CONFIRMED: 'BEFORE_BOOKING_CONFIRMED',
};

export const COUNTDOWN_UNIT_OPTION = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
};

export const FREQUENCY_UNIT_OPTION = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
};

export const THRESHOLD_UNIT_OPTION = {
  INVENTORY_PIECE: 'INVENTORY_PIECE',
  BOOKING_COUNT: 'BOOKING_COUNT',
};

export const MODE_OF_ARRIVAL = {
  DOMESTIC_ARRIVAL: 'DOMESTIC_ARRIVAL',
  INTERNATIONAL_ARRIVAL: 'INTERNATIONAL_ARRIVAL',
};

export const GET_STUDENTS_ROOM_LOCATION = {
  ALL: 'ALL',
  RESIDENT_ONLY: 'RESIDENT_ONLY',
};

export const INSPECTION_ITEM_CATEGORY = {
  BEDROOM: 'BEDROOM',
  KITCHEN_AREA: 'KITCHEN_AREA',
  EN_SUITE: 'EN_SUITE',
};

export const INSPECTION_ITEM_STATUS = {
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  NOT_EXISTED: 'NOT_EXISTED',
};

export const FINANCIAL_STATUS = {
  IN_BALANCE: 'IN_BALANCE',
  IN_ARREARS: 'IN_ARREARS',
  IN_CREDIT: 'IN_CREDIT',
};

export const DOCUMENT_SETTING_CATEGORY = {
  /**
   * This is equivalent to uploading file at access level `student_and_landlord`
   */
  STUDENT_RELATED: 'STUDENT_RELATED',
  /**
   * This is equivalent to uploading file at access level `student_and_property`
   */
  BOOKING_RELATED: 'BOOKING_RELATED',
};

export const TITLE = {
  DR: 'DR',
  MR: 'MR',
  MRS: 'MRS',
  MS: 'MS',
  PROF: 'PROF',
  MISS: 'MISS',
  MX: 'MX',
};

export const PAYMENT_ITEM_STATUS = {
  OPEN: 'OPEN',
  INVOICED: 'INVOICED',
  REMAINING: 'REMAINING',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  VOID: 'VOID',
  REFUNDED: 'REFUNDED',
  DEPOSITED: 'DEPOSITED',
  PENDING: 'PENDING',
  RETURNED: 'RETURNED',
  TRANSFERRED: 'TRANSFERRED',
  AWAITING: 'AWAITING',
  WAIVED: 'WAIVED',
};

export const TRANSACTION_TYPE_OPTIONS = {
  PAYMENT: 'PAYMENT',
  ALLOCATION: 'ALLOCATION',
  CHARGE: 'CHARGE',
  REFUND: 'REFUND',
  TRANSFER_TO: 'TRANSFER_TO',
  TRANSFER_FROM: 'TRANSFER_FROM',
  CREDIT_TRANSFER_TO: 'CREDIT_TRANSFER_TO',
  CREDIT_TRANSFER_FROM: 'CREDIT_TRANSFER_FROM',
  DEPOSIT: 'DEPOSIT',
  REVERSAL_CHARGE: 'REVERSAL_CHARGE',
  REVERSAL_ALLOCATION: 'REVERSAL_ALLOCATION',
  REVERSAL_DEPOSIT: 'REVERSAL_DEPOSIT',
  REQUEST: 'REQUEST',
  REVERSAL_REQUEST: 'REVERSAL_REQUEST',
  REVERSAL_PAYMENT: 'REVERSAL_PAYMENT',
  REDEMPTION: 'REDEMPTION',
  REVERSAL_REDEMPTION: 'REVERSAL_REDEMPTION',
  BALANCE_TRANSFER: 'BALANCE_TRANSFER',
  CREDIT_REFUND: 'CREDIT_REFUND',
  AMENDMENT_CREDIT: 'AMENDMENT_CREDIT',
  CREDIT_ALLOCATION: 'CREDIT_ALLOCATION',
  REVERSAL_AMENDMENT_CREDIT: 'REVERSAL_AMENDMENT_CREDIT',
};

export const TRANSACTION_CATEGORY_OPTIONS = {
  ADMINISTRATION_FEE: 'ADMINISTRATION_FEE',
  COMMERCIAL: 'COMMERCIAL',
  CONSUMABLE: 'CONSUMABLE',
  DAMAGE: 'DAMAGE',
  DISCOUNT: 'DISCOUNT',
  NOMINATION: 'NOMINATION',
  OTHER: 'OTHER',
  RENTAL: 'RENTAL',
  SERVICE: 'SERVICE',
};

export const TRANSACTION_CHANNEL_OPTIONS = {
  OFFLINE: 'OFFLINE',
  STRIPE: 'STRIPE',
  BRAINTREE: 'BRAINTREE',
  BPOINT: 'BPOINT',
  SAGE_PAY: 'SAGE_PAY',
  STARREZ: 'STARREZ',
  BALANCE: 'BALANCE',
  OTHER: 'OTHER',
};

export const TRANSACTION_METHOD_OPTIONS = {
  CASH: 'CASH',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CHEQUE: 'CHEQUE',
  CREDIT_CARD: 'CREDIT_CARD',
  DEBIT_CARD: 'DEBIT_CARD',
  WALLET_BALANCE: 'WALLET_BALANCE',
  PAY_TO_STUDY: 'PAY_TO_STUDY',
  OTHER: 'OTHER',
};

export const CARD_BRAND_OPTIONS = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
  DINERS_CLUB: 'DINERS_CLUB',
  INTERAC: 'INTERAC',
  UNION_PAY: 'UNION_PAY',
  CARTES_BANCAIRES: 'CARTES_BANCAIRES',
  EFTPOS_AUSTRALIA: 'EFTPOS_AUSTRALIA',
  AMEX: 'AMEX',
  DINERS: 'DINERS',
  DISCOVER: 'DISCOVER',
  JCB: 'JCB',
  UNIONPAY: 'UNIONPAY',
  UNKNOWN: 'UNKNOWN',
  DELTA: 'DELTA',
  OTHER: 'OTHER',
};

export const CARD_BRAND_OPTIONS_CREATE_PAYMENT = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMEX: 'AMEX',
  DINERS: 'DINERS',
  DISCOVER: 'DISCOVER',
  JCB: 'JCB',
  UNIONPAY: 'UNIONPAY',
  UNKNOWN: 'UNKNOWN',
  DELTA: 'DELTA',
  OTHER: 'OTHER',
};

export const TAX_SCOPE_LEVEL_OPTIONS = {
  COUNTRY: 'COUNTRY',
  CITY: 'CITY',
};

export const SOURCE = {
  GIBBS: 'GIBBS',
  STUDENT_PORTAL: 'STUDENT_PORTAL',
};

export const CANCEL_BOOKING_PAYMENT_ITEM_STATUS = {
  TRANSFER_TO_AMENDMENT_CREDIT: 'TRANSFER_TO_AMENDMENT_CREDIT',
  WAIVED: 'WAIVED',
  KEEP_CHARGE: 'KEEP_CHARGE',
  TRANSFER_TO_BOOKING: 'TRANSFER_TO_BOOKING',
};

export const CANCELLED_REASON = {
  BOOKING_AMENDMENT: 'BOOKING_AMENDMENT',
  CHANGE_OF_MIND: 'CHANGE_OF_MIND',
  FAILURE_TO_RECEIVE_GRADES: 'FAILURE_TO_RECEIVE_GRADES',
  FAILURE_TO_OBTAIN_VISA: 'FAILURE_TO_OBTAIN_VISA',
  BOOKED_WITH_COMPETITORS_PBSA: 'BOOKED_WITH_COMPETITORS_PBSA',
  BOOKED_WITH_UNIVERSITY_ACCOMMODATION: 'BOOKED_WITH_UNIVERSITY_ACCOMMODATION',
  DECIDED_TO_STUDY_IN_AN_ALTERNATIVE_DESTINATION: 'DECIDED_TO_STUDY_IN_AN_ALTERNATIVE_DESTINATION',
  ILLNESS: 'ILLNESS',
  FINANCIAL_SITUATION_HAS_CHANGED: 'FINANCIAL_SITUATION_HAS_CHANGED',
  EXTENUATING_CIRCUMSTANCES: 'EXTENUATING_CIRCUMSTANCES',
  TEST_DATA: 'TEST_DATA',
  POLICY_BASED_CANCELLATION: 'POLICY_BASED_CANCELLATION',
  OTHER: 'OTHER',
};

export const REFUND_STATUS_TYPE = {
  NO_REFUND: 'NO_REFUND',
  PENDING: 'PENDING',
  REFUNDED: 'REFUNDED',
  TRANSFERRED: 'TRANSFERRED',
};

export const CONTRACT_FILE_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export const DEGREE_CLASSIFICATION = {
  UNDERGRADUATE: 'UNDERGRADUATE',
  MASTERS: 'MASTERS',
  DOCTORAL: 'DOCTORAL',
  LANGUAGE_COURSE: 'LANGUAGE_COURSE',
  FOUNDATION: 'FOUNDATION',
  OTHER: 'OTHER',
};

export const DISCOUNT_TYPE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
  FIXED_NIGHTS: 'FIXED_NIGHTS',
};

export const RENT_TYPE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  FIXED_NIGHTS: 'FIXED_NIGHTS',
  PERCENTAGE: 'PERCENTAGE',
  EQUAL_PARTS: 'EQUAL_PARTS',
};

export const RENT_TYPE_NO_FIXED_NIGHTS = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
};

export const ADDITIONAL_FEE_RENT_OPTIONS = {
  TOTAL_PRICE: 'TOTAL_PRICE',
  RENT_ONLY: 'RENT_ONLY',
};

export const CUSTOMIZED_INSTALLMENT_RENT_TYPE = {
  FIXED_NIGHTS: 'FIXED_NIGHTS',
  PERCENTAGE: 'PERCENTAGE',
  EQUAL_PARTS: 'EQUAL_PARTS',
};

export const INSTALLMENT_TYPE = {
  FULL: 'FULL',
  WEEKLY: 'WEEKLY',
  FORTNIGHTLY: 'FORTNIGHTLY',
  MONTHLY: 'MONTHLY',
  CUSTOMIZED: 'CUSTOMIZED',
};

export const RATE_TYPE = {
  EXISTING: 'EXISTING',
  LIVE: 'LIVE',
  FREE: 'FREE',
};

export const NO_LIVE_RATE_TYPE = {
  EXISTING: 'EXISTING',
  FREE: 'FREE',
};

export const NON_FREE_RATE_TYPE = {
  EXISTING: 'EXISTING',
  LIVE: 'LIVE',
  SPECIAL_RATE: 'SPECIAL_RATE',
};

export const ROLL_OVER_BOOKING_RATE_TYPE = {
  STAGGERED: 'STAGGERED',
  SPECIAL_RATE: 'SPECIAL_RATE',
};

export const NON_FREE_AND_LIVE_RATE_TYPE = {
  EXISTING: 'EXISTING',
  SPECIAL_RATE: 'SPECIAL_RATE',
};

export const CHECK_IN_AND_CHECK_OUT_PROCESS_TYPE = {
  QUICK_PASS: 'QUICK_PASS',
  GO_THROUGH_ENTIRE_PROCESS: 'GO_THROUGH_ENTIRE_PROCESS',
};

export const CHECK_IN_ERROR_TYPE = {
  TO_COMPLETE: 'TO_COMPLETE',
  TO_CHECK_OUT: 'TO_CHECK_OUT',
  TO_CHECK_IN: 'TO_CHECK_IN',
};

export const TERMINATED_REASON = {
  BOOKING_AMENDMENT: 'BOOKING_AMENDMENT',
  ILLNESS: 'ILLNESS',
  EXTENUATING_CIRCUMSTANCES: 'EXTENUATING_CIRCUMSTANCES',
  COURSE_CHANGE_TO_DISTANCE_LEARNING: 'COURSE_CHANGE_TO_DISTANCE_LEARNING',
  DEFERRAL_OF_ACADEMIC_YEAR: 'DEFERRAL_OF_ACADEMIC_YEAR',
  COVID_19_RELATED: 'COVID_19_RELATED',
  POLICY_BASED_CANCELLATION: 'POLICY_BASED_CANCELLATION',
  OTHER: 'OTHER',
};

export const AMENDMENT_DETAIL = {
  BED: 'BED',
  INSTALLMENT: 'INSTALLMENT',
  GUARANTOR: 'GUARANTOR',
  TENANCY_CHANGE_ENTIRELY: 'TENANCY_CHANGE_ENTIRELY',
  TENANCY_SHORTEN_LATER_CHECK_IN: 'TENANCY_SHORTEN_LATER_CHECK_IN',
  TENANCY_SHORTEN_EARLY_CHECK_OUT: 'TENANCY_SHORTEN_EARLY_CHECK_OUT',
  TENANCY_EXTEND_EARLY_CHECK_IN: 'TENANCY_EXTEND_EARLY_CHECK_IN',
  TENANCY_EXTEND_LATER_CHECK_OUT: 'TENANCY_EXTEND_LATER_CHECK_OUT',
  CANCELLATION: 'CANCELLATION',
  SERVICE: 'SERVICE',
  ALL_IN_ONE: 'ALL_IN_ONE',
  TAKEOVER: 'TAKEOVER',
};

export const TAX_APPLIED_OPTION = {
  STUDENT: 'STUDENT',
  INDIVIDUAL: 'INDIVIDUAL',
  COMPANY: 'COMPANY',
};

export const SALES_ITEM_CATEGORY_OPTION = {
  ADMINISTRATION_FEE: 'ADMINISTRATION_FEE',
  COMMERCIAL: 'COMMERCIAL',
  CONSUMABLE: 'CONSUMABLE',
  DAMAGE: 'DAMAGE',
  DISCOUNT: 'DISCOUNT',
  NOMINATION: 'NOMINATION',
  RENTAL: 'RENTAL',
  SERVICE: 'SERVICE',
  UTILITY_COSTS: 'UTILITY_COSTS',
  OTHER: 'OTHER',
};

export const CHARGE_FREQUENCY_OPTIONS = {
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY',
};

// exclude [NOMINATION && RENTAL]
export const SALES_ITEM_CATEGORY_OPTION_BOOKING_VALUE = {
  ADMINISTRATION_FEE: 'ADMINISTRATION_FEE',
  COMMERCIAL: 'COMMERCIAL',
  CONSUMABLE: 'CONSUMABLE',
  DAMAGE: 'DAMAGE',
  DISCOUNT: 'DISCOUNT',
  SERVICE: 'SERVICE',
  UTILITY_COSTS: 'UTILITY_COSTS',
  OTHER: 'OTHER',
};

export const SALES_ITEM_LINKAGE_OPTION = {
  NOMINATION_RENTAL: 'NOMINATION_RENTAL',
  ADDITIONAL_FEE: 'ADDITIONAL_FEE',
  PLAN_NOMINATION_RENTAL: 'PLAN_NOMINATION_RENTAL',

  NORMAL_RENTAL: 'NORMAL_RENTAL',
  SHORT_STAY_RENTAL: 'SHORT_STAY_RENTAL',
};

// sort by alphabetical
export const BOOKING_REFERRAL = {
  a_s_l_e_n_edu: 'a_s_l_e_n_edu',
  aas: 'aas',
  abg_group: 'abg_group',
  abroadre: 'abroadre',
  academe: 'academe',
  academic_asia_taiwan_att: 'academic_asia_taiwan_att',
  access_academic_consultancy_hk: 'access_academic_consultancy_hk',
  accommodation_for_students: 'accommodation_for_students',
  ace_home_living: 'ace_home_living',
  acic_education: 'acic_education',
  acolyte_living: 'acolyte_living',
  ada_edu: 'ada_edu',
  admistay: 'admistay',
  ahead_edu: 'ahead_edu',
  aiat: 'aiat',
  airoluggage_com: 'airoluggage_com',
  aiuk: 'aiuk',
  al_ahlam_higher_education_services: 'al_ahlam_higher_education_services',
  albert_school: 'albert_school',
  alfalink_education: 'alfalink_education',
  alphaway: 'alphaway',
  amber_student: 'amber_student',
  aohua_international_education: 'aohua_international_education',
  aoji_education_australia: 'aoji_education_australia',
  atlantic_bridge: 'atlantic_bridge',
  aug_student_services: 'aug_student_services',
  aussie_study: 'aussie_study',
  aussizz_group: 'aussizz_group',
  australia_career_centre_acc: 'australia_career_centre_acc',
  australia_institute_of_further_studies: 'australia_institute_of_further_studies',
  australia_study_visa_services: 'australia_study_visa_services',
  australian_education_association_aea: 'australian_education_association_aea',
  australian_education_association: 'australian_education_association',
  australian_education_migration_services: 'australian_education_migration_services',
  australian_standard_education: 'australian_standard_education',
  aval_student: 'aval_student',
  avanti: 'avanti',
  awehome: 'awehome',
  b_happy_cambridge: 'b_happy_cambridge',
  b_solution: 'b_solution',
  b1_soccer_elite_academic: 'b1_soccer_elite_academic',
  banana_monkey: 'banana_monkey',
  bcu: 'bcu',
  beijing_zhong: 'beijing_zhong',
  bella_language: 'bella_language',
  belloliving: 'belloliving',
  besa_group: 'besa_group',
  best_student_halls: 'best_student_halls',
  betahouse: 'betahouse',
  beyond_campus: 'beyond_campus',
  beyond_education: 'beyond_education',
  biwpa: 'biwpa',
  blue_education_migration: 'blue_education_migration',
  bluesky_immigration_students_consultancy_services:
    'bluesky_immigration_students_consultancy_services',
  bm_home: 'bm_home',
  boarding_schools_ireland: 'boarding_schools_ireland',
  bookmyuniroom: 'bookmyuniroom',
  boomerang_australia_studies: 'boomerang_australia_studies',
  brand_university: 'brand_university',
  bright_columbia: 'bright_columbia',
  bwonder: 'bwonder',
  campusboard: 'campusboard',
  can_akarka: 'can_akarka',
  casita: 'casita',
  central_student_services: 'central_student_services',
  chengle_education: 'chengle_education',
  chic_education: 'chic_education',
  chris_living: 'chris_living',
  clozhome_com: 'clozhome_com',
  collegedream: 'collegedream',
  conexioneseducativas: 'conexioneseducativas',
  curio_education: 'curio_education',
  cw_room: 'cw_room',
  d_hub: 'd_hub',
  daniel_global_education: 'daniel_global_education',
  deferral: 'deferral',
  destinazionelingue: 'destinazionelingue',
  dj_student_services: 'dj_student_services',
  dondememeto: 'dondememeto',
  dorms_com: 'dorms_com',
  dorset_college: 'dorset_college',
  dte: 'dte',
  dubai_city_football_club: 'dubai_city_football_club',
  dublinnest: 'dublinnest',
  duc_anh_a_t: 'duc_anh_a_t',
  edcon_com: 'edcon_com',
  edu_consulting: 'edu_consulting',
  edu_gate_libya: 'edu_gate_libya',
  edu_kwanza: 'edu_kwanza',
  education_international_cooperation_eic_group: 'education_international_cooperation_eic_group',
  education_state: 'education_state',
  educomoverseas: 'educomoverseas',
  eduhomely: 'eduhomely',
  edulipse: 'edulipse',
  eduterra: 'eduterra',
  eduworld: 'eduworld',
  eeriv: 'eeriv',
  egida: 'egida',
  elite_student: 'elite_student',
  elite: 'elite',
  embry_riddle_aeronautical_university_era: 'embry_riddle_aeronautical_university_era',
  english_path: 'english_path',
  erasmusplay: 'erasmusplay',
  etudier_en_espagne: 'etudier_en_espagne',
  experience_wa_japan: 'experience_wa_japan',
  expert_education_visa_services: 'expert_education_visa_services',
  feeduc: 'feeduc',
  ferco_advanced_education: 'ferco_advanced_education',
  firenze_egitim: 'firenze_egitim',
  five_one_room_com: 'five_one_room_com',
  fly_homes: 'fly_homes',
  foreign_settle_in: 'foreign_settle_in',
  fragomen: 'fragomen',
  franc_espagne_education: 'franc_espagne_education',
  frankfurt_school: 'frankfurt_school',
  funliving_com: 'funliving_com',
  fyndix: 'fyndix',
  global_business_school: 'global_business_school',
  global_education_alliance: 'global_education_alliance',
  go_go_world: 'go_go_world',
  go_study_australia: 'go_study_australia',
  gowooda_com: 'gowooda_com',
  her_roomies: 'her_roomies',
  heymati: 'heymati',
  himanshu: 'himanshu',
  hino_student: 'hino_student',
  hispano_chino: 'hispano_chino',
  homelike: 'homelike',
  hoolihomes: 'hoolihomes',
  house_of_student: 'house_of_student',
  housemates: 'housemates',
  housing_anywhere: 'housing_anywhere',
  ice_sugar_pty_ltd: 'ice_sugar_pty_ltd',
  idp_education: 'idp_education',
  immobilinescout: 'immobilinescout',
  inlifehousing: 'inlifehousing',
  inmersion_uk: 'inmersion_uk',
  inmo_scout: 'inmo_scout',
  inmobiliaria_360: 'inmobiliaria_360',
  ino_agency: 'ino_agency',
  international_centre_for_culinary_arts: 'international_centre_for_culinary_arts',
  isec: 'isec',
  jack_study_abroad: 'jack_study_abroad',
  karya: 'karya',
  kc_overseas_education: 'kc_overseas_education',
  koskosan: 'koskosan',
  kyroom: 'kyroom',
  lanma_education: 'lanma_education',
  last_resort_australia_limited: 'last_resort_australia_limited',
  lat_education: 'lat_education',
  leverage_edu: 'leverage_edu',
  linktop_global: 'linktop_global',
  live4_life: 'live4_life',
  liweostudent_com: 'liweostudent_com',
  lodgerin: 'lodgerin',
  londonist: 'londonist',
  matrix_global: 'matrix_global',
  meit: 'meit',
  meta_apply: 'meta_apply',
  milner: 'milner',
  mioliving: 'mioliving',
  monroy_counseling: 'monroy_counseling',
  mr_global_academy: 'mr_global_academy',
  myrentconnect: 'myrentconnect',
  nbs: 'nbs',
  nest_academy_of_management_education: 'nest_academy_of_management_education',
  niec_indonesia: 'niec_indonesia',
  niec: 'niec',
  northern_business_shool: 'northern_business_shool',
  oal: 'oal',
  ocxee_com: 'ocxee_com',
  ocxee_ltd: 'ocxee_ltd',
  ola_education: 'ola_education',
  ole_living: 'ole_living',
  pad_overseas: 'pad_overseas',
  panlengua: 'panlengua',
  pepe_housing: 'pepe_housing',
  perilpos: 'perilpos',
  photiades: 'photiades',
  pisa_education: 'pisa_education',
  plus_education: 'plus_education',
  prestige_education: 'prestige_education',
  punuoliving: 'punuoliving',
  quartier_latin: 'quartier_latin',
  re_abroad_inc: 're_abroad_inc',
  residencias_universitarias: 'residencias_universitarias',
  resooma: 'resooma',
  ritrain_education: 'ritrain_education',
  roombae: 'roombae',
  roomies: 'roomies',
  roomlessrent: 'roomlessrent',
  school_in_the_world: 'school_in_the_world',
  see_homes: 'see_homes',
  shanghai_h_b: 'shanghai_h_b',
  siec: 'siec',
  sky_education_migration: 'sky_education_migration',
  sophiya_consultants: 'sophiya_consultants',
  spaceforedu: 'spaceforedu',
  speak_english: 'speak_english',
  speakeasy: 'speakeasy',
  spotahome: 'spotahome',
  staykeepers: 'staykeepers',
  student_com: 'student_com',
  student_homes_korea: 'student_homes_korea',
  student_house: 'student_house',
  student_it: 'student_it',
  student_living: 'student_living',
  student_mundial: 'student_mundial',
  student_nest: 'student_nest',
  student_pro_plus: 'student_pro_plus',
  student_room_rentals: 'student_room_rentals',
  student_travel_ukraine: 'student_travel_ukraine',
  studentfy: 'studentfy',
  studentguru_com_au: 'studentguru_com_au',
  studentproplus: 'studentproplus',
  students_barcelona: 'students_barcelona',
  studies_barcelona: 'studies_barcelona',
  studies_in: 'studies_in',
  studies_up: 'studies_up',
  study_experience_fr: 'study_experience_fr',
  study_stay: 'study_stay',
  studyinbarcelona: 'studyinbarcelona',
  studylease: 'studylease',
  studyzone: 'studyzone',
  stuliving: 'stuliving',
  superstar_education: 'superstar_education',
  the_football_academy: 'the_football_academy',
  think_thank_global: 'think_thank_global',
  transatlantic_education_student_services: 'transatlantic_education_student_services',
  tredu: 'tredu',
  trinity_college_dublin: 'trinity_college_dublin',
  tu_darmstadt: 'tu_darmstadt',
  tu_dublin: 'tu_dublin',
  uccse: 'uccse',
  uhomes: 'uhomes',
  ukde: 'ukde',
  ulodging_com: 'ulodging_com',
  umovest: 'umovest',
  uni_living_space: 'uni_living_space',
  uniacco: 'uniacco',
  unidream: 'unidream',
  unilodgers: 'unilodgers',
  uniplaces: 'uniplaces',
  uniresi: 'uniresi',
  uniscopio: 'uniscopio',
  universal_student_homes: 'universal_student_homes',
  universidad_sigo: 'universidad_sigo',
  university_hamburg: 'university_hamburg',
  university_living: 'university_living',
  univoyage_com_au: 'univoyage_com_au',
  ustayz: 'ustayz',
  utalent: 'utalent',
  uziliving: 'uziliving',
  via_academica: 'via_academica',
  visa_2_go: 'visa_2_go',
  vivacity: 'vivacity',
  waterfront: 'waterfront',
  we_desi_homes: 'we_desi_homes',
  west_1: 'west_1',
  west_aussie_education: 'west_aussie_education',
  wggesucht: 'wggesucht',
  wheat_education: 'wheat_education',
  william_h_brown: 'william_h_brown',
  wmeir_winja_partners: 'wmeir_winja_partners',
  yes_education: 'yes_education',
  yihome: 'yihome',
  ziroom: 'ziroom',
  // [6apt.com] is number header, on the bottom of referral list
  six_apt_com: 'six_apt_com',
  four_braves: 'four_braves',
};

export const AMENDMENT_DETAIL_STATUS = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  COMPLETED: 'COMPLETED',
};

export const PAYMENT_ITEM_MODEL = {
  INSTALLMENT: 'INSTALLMENT',
  ADDITIONAL_FEE: 'ADDITIONAL_FEE',
  INSPECTION_REPORT_ITEM: 'INSPECTION_REPORT_ITEM',
  TRANSACTION_FEE: 'TRANSACTION_FEE',
};

export const PARTNER_TYPE = {
  UNIVERSITY: 'UNIVERSITY',
  SERVICE_COMPANY: 'SERVICE_COMPANY',
  VOUCHER_SUPPLIER: 'VOUCHER_SUPPLIER',
  BOND_AUTHORITY: 'BOND_AUTHORITY',
  DEPOSIT_AUTHORITY: 'DEPOSIT_AUTHORITY',
  BUSINESS_GROUP: 'BUSINESS_GROUP',
};

export const PAY_TO_TYPE_OPTIONS = {
  RESIDENCE: 'RESIDENCE',
  PARTNER: 'PARTNER',
};

export const INVOICE_CALCULATION_TYPE_OPTIONS = {
  CONTRACT_TERM: 'CONTRACT_TERM',
  BOOKING_VALUE: 'BOOKING_VALUE',
};

export const OFFER_STATUS_OPTION = {
  NOT_OFFERED: 'NOT_OFFERED',
  OFFERED: 'OFFERED',
};

export const CUSTOM_FIELD_TYPE = {
  EXTERNAL_ID: 'EXTERNAL_ID',
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  REBOOKER_TAG: 'REBOOKER_TAG',
  PERSONAL: 'PERSONAL',
  THIRD_PARTY: 'THIRD_PARTY',
  FINANCE_TAG: 'FINANCE_TAG',
  CONTRACT_TAG: 'CONTRACT_TAG',
};

export const CUSTOM_FIELD_FORMAT = {
  SHORT_TEXT: 'SHORT_TEXT',
  PICKLIST: 'PICKLIST',
};

export const OFFER_STATUS = {
  NOT_OFFERED: 'NOT_OFFERED',
  OFFERED: 'OFFERED',
};

export const SPECIAL_OFFER_TYPE = {
  DISCOUNT: 'DISCOUNT',
};

export const SPECIAL_OFFER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const SPECIAL_OFFER_DISCOUNT_ITEM_TYPE = {
  TOTAL_RENT: 'TOTAL_RENT',
  RENT_ONLY: 'RENT_ONLY',
};

export const SPECIAL_OFFER_DISCOUNT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  FIXED_NIGHTS: 'FIXED_NIGHTS',
};

export const SPECIAL_OFFER_APPLICATION_SCOPE_OPTIONS = {
  NORMAL_SALE: 'NORMAL_SALE',
  CAMPAIGN_SALE: 'CAMPAIGN_SALE',
  NOT_SPECIFIC: 'NOT_SPECIFIC',
};

export const SPECIAL_OFFER_DISCOUNT_RULE = {
  NET_VALUE: 'NET_VALUE',
  GROSS_VALUE: 'GROSS_VALUE',
};

export const SPECIAL_OFFER_CRITERIA_TYPE = {
  TOTAL_RENT: 'TOTAL_RENT',
  TENANCY_LENGTH: 'TENANCY_LENGTH',
  TENANCY_OPTIONS: 'TENANCY_OPTIONS',
  ROOM_TYPES: 'ROOM_TYPES',
  INSTALLMENTS: 'INSTALLMENTS',
};

export const SPECIAL_OFFER_CHANNEL_STATUS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  SCHEDULED: 'SCHEDULED',
};

export const LINK_EMAIL_TYPE = {
  OFFER_BOOKING_FROM_GIBBS: 'OFFER_BOOKING_FROM_GIBBS',
  REMINDER_EMAIL_FOR_BOOKING_EXPIRED: 'REMINDER_EMAIL_FOR_BOOKING_EXPIRED',
  CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED: 'CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED',
  SET_ACCOUNT: 'SET_ACCOUNT',
};

export const CRITERION_TYPE_OPTIONS = {
  INSTALLMENTS: 'INSTALLMENTS',
  ROOM_TYPES: 'ROOM_TYPES',
  TENANCY_LENGTH: 'TENANCY_LENGTH',
  TENANCY_OPTIONS: 'TENANCY_OPTIONS',
  TOTAL_RENT: 'TOTAL_RENT',
};

export const BULK_TASK_ACTION_OPTIONS = {
  ALLOCATION_BED: 'ALLOCATION_BED',
  AUTO_ALLOCATION_BED: 'AUTO_ALLOCATION_BED',
  IMPORT_BED: 'IMPORT_BED',
  IMPORT_STUDENT: 'IMPORT_STUDENT',
  OFFER_BOOKING: 'OFFER_BOOKING',
  BULK_AMEND_BOOKING_STATUS: 'BULK_AMEND_BOOKING_STATUS',
  BULK_CHECK_IN_BOOKINGS: 'BULK_CHECK_IN_BOOKINGS',
  BULK_CHECK_OUT_BOOKINGS: 'BULK_CHECK_OUT_BOOKINGS',
  CHANGE_SERVICE: 'CHANGE_SERVICE',
  BULK_UPDATE_STUDENTS: 'BULK_UPDATE_STUDENTS',
  BULK_CREATE_PLACEHOLDER_STUDENT: 'BULK_CREATE_PLACEHOLDER_STUDENT',
  BULK_SEND_BOOKING_EMAIL: 'BULK_SEND_BOOKING_EMAIL',
  BULK_ADD_CHARGE: 'BULK_ADD_CHARGE',
  BULK_IMPORT_STUDENT_WITH_ID: 'BULK_IMPORT_STUDENT_WITH_ID',
  IMPORT_CARD_CONFIG: 'IMPORT_CARD_CONFIG',
  VALIDATE_PROPERTY_STRUCTURE: 'VALIDATE_PROPERTY_STRUCTURE',
  IMPORT_PROPERTY_STRUCTURE: 'IMPORT_PROPERTY_STRUCTURE',
  EXPORT_BOOKINGS: 'EXPORT_BOOKINGS',
};

export const BULK_TASK_STATUS_OPTIONS = {
  FAILED: 'FAILED',
  PARTIALLY_FAILED: 'PARTIALLY_FAILED',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  QUEUED: 'QUEUED',
  CREATED: 'CREATED',
};

export const STUDENT_TO_OFFER_TYPE = {
  STUDENT_WITHOUT_BED: 'STUDENT_WITHOUT_BED',
  STUDENT_WITH_BED: 'STUDENT_WITH_BED',
};

export const SPECIAL_OFFER_INSTALLMENT_TYPE = {
  FULL: 'FULL',
};

export const DESTINATION_ACCOUNT_TYPE = {
  RENTAL: 'RENTAL',
  DEPOSIT: 'DEPOSIT',
};

export const TRANSFER_CHANNEL_TYPE = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export const PAYMENT_METHOD_TYPE_OPTIONS = {
  CARD: 'CARD',
  RECURRING_PAYMENT: 'RECURRING_PAYMENT',
  AU_BECS_DEBIT: 'AU_BECS_DEBIT',
  BACS_DEBIT: 'BACS_DEBIT',
  SEPA_DEBIT: 'SEPA_DEBIT',
  BANK_TRANSFER: 'BANK_TRANSFER',
};

export const PAYMENT_TYPE = {
  RENTAL: 'RENTAL',
  DEPOSIT: 'DEPOSIT',
};

export const FORM_SETTING_TENANCY_TYPE = {
  ALL: 'ALL',
  NORMAL: 'NORMAL',
  SHORT_TERM: 'SHORT_TERM',
};

export const FORM_SETTING_TYPE = {
  DISPLAY: 'DISPLAY',
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  ACCEPT_OR_REJECT: 'ACCEPT_OR_REJECT',
  // CUSTOMIZED_INPUT: 'CUSTOMIZED_INPUT',
};

export const INSTALLMENT_APPLICABILITY = {
  NOT_SPECIFIC: 'NOT_SPECIFIC',
  NOT_APPLICABLE_FOR_FULL_PAYMENT: 'NOT_APPLICABLE_FOR_FULL_PAYMENT',
  ONLY_APPLICABLE_FOR_FULL_PAYMENT: 'ONLY_APPLICABLE_FOR_FULL_PAYMENT',
};

export const NOMINATION_BOOKING_TYPE_OPTIONS = {
  NOMINATION_THIRD_PARTY: 'NOMINATION_THIRD_PARTY',
  BUSINESS_GROUP: 'BUSINESS_GROUP',
  NOMINATION_REFERRER: 'NOMINATION_REFERRER',
  DIRECT_LET: 'DIRECT_LET',
};

export const STAFF_NOTE_CATEGORY = {
  GENERAL: 'GENERAL',
  FINANCES: 'FINANCES',
  WELLBEING: 'WELLBEING',
  SALES: 'SALES',
  BEHAVIOUR: 'BEHAVIOUR',
};

export const STAFF_NOTE_TYPE = {
  NOTE: 'NOTE',
  TASK: 'TASK',
};

export const STAFF_NOTE_STATUS = {
  OPEN: 'OPEN',
  REOPENED: 'REOPENED',
  RESOLVED: 'RESOLVED',
};

export const DOCUMENT_SETTING_CATEGORY_OPTIONS = {
  STUDENT_RELATED: 'STUDENT_RELATED',
  BOOKING_RELATED: 'BOOKING_RELATED',
  GUARANTOR_RELATED: 'GUARANTOR_RELATED',
};

export const OFFER_BOOKING_TEMPLATE_TYPE = {
  OFFER_BOOKING_FROM_GIBBS: 'OFFER_BOOKING_FROM_GIBBS',
  SET_ACCOUNT: 'SET_ACCOUNT',
};

export const SLOT_LENGTH = {
  ONE_HOUR: 'ONE_HOUR',
  HALF_HOUR: 'HALF_HOUR',
};

export const CREDIT_TRANSCATION_CATEGORY_OPTIONS = {
  RENT_PROMOTION: 'RENT_PROMOTION',
  NON_RENT_PROMOTION: 'NON_RENT_PROMOTION',
};

export const ACADEMIC_YEAR_STATUS = {
  CURRENT: 'CURRENT',
  PAST: 'PAST',
};

export const PREFERRED_GENDER_PRONOUN_OPTIONS = {
  HE_HIM: 'HE_HIM',
  HE_THEY: 'HE_THEY',
  HE_HER: 'HE_HER',
  SHE_HER: 'SHE_HER',
  SHE_THEY: 'SHE_THEY',
  SHE_HIM: 'SHE_HIM',
  THEY_THEM: 'THEY_THEM',
};

export const PAYMENT_METHOD_RECORD_TYPE = {
  CARD: 'CARD',
  SEPA_DEBIT: 'SEPA_DEBIT',
  BACS_DEBIT: 'BACS_DEBIT',
  AU_BECS_DEBIT: 'AU_BECS_DEBIT',
};

export const COUNTDOWN_STAGE_OF_NOMINATION_PLAN_OPTIONS = {
  BEFORE_BOOKING_CONFIRMED: 'BEFORE_BOOKING_CONFIRMED',
  AMENDMENT_BEFORE_TERMS_ACCEPTED: 'AMENDMENT_BEFORE_TERMS_ACCEPTED',
  AMENDMENT_BEFORE_BOOKING_CONFIRMED: 'AMENDMENT_BEFORE_BOOKING_CONFIRMED',
  BEFORE_BOOKING_CONFIRMED_IN_BANK_TRANSFER: 'BEFORE_BOOKING_CONFIRMED_IN_BANK_TRANSFER',
  AMENDMENT_BEFORE_BOOKING_CONFIRMED_IN_BANK_TRANSFER:
    'AMENDMENT_BEFORE_BOOKING_CONFIRMED_IN_BANK_TRANSFER',
};

export const BALANCE_TYPE = {
  WALLET_BALANCE: 'WALLET_BALANCE',
  AMENDMENT_CREDIT_BALANCE: 'AMENDMENT_CREDIT_BALANCE',
};

export const BOOKING_LINK_STATUS_TYPE_OPTIONS = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  COMPLETED: 'COMPLETED',
};

export const TIME_LENGTH_TO_HOLD_THE_BED_OPTIONS = {
  ENTIRE_TENANCY_LENGTH: 'ENTIRE_TENANCY_LENGTH',
  ENTIRE_PLAN_DATE_RANGE: 'ENTIRE_PLAN_DATE_RANGE',
};

export const DISPLAY_BED_STATUS_OPTIONS = {
  CAMPAIGN: 'CAMPAIGN',
  NOMINATED: 'NOMINATED',
};

export const FUNCTION_NAME_OPTIONS = {
  PARTNER: 'PARTNER',
  FINANCE_BALANCE: 'FINANCE_BALANCE',
  TENANCY_OPTION: 'TENANCY_OPTION',
  SALES_ITEM: 'SALES_ITEM',
  PRICE: 'PRICE',
  FACTOR_CARD: 'FACTOR_CARD',
  SERVICE_CARD: 'SERVICE_CARD',
  ADDITIONAL_FEE: 'ADDITIONAL_FEE',
  SPECIAL_OFFER: 'SPECIAL_OFFER',
  CONTRACT_TEMPLATE: 'CONTRACT_TEMPLATE',
  EMAIL_TEMPLATE: 'EMAIL_TEMPLATE',
  CHECK_IN_FORM: 'CHECK_IN_FORM',
  FLEXIBILITY_CONTROL: 'FLEXIBILITY_CONTROL',
};

export const FUNCTION_STATUS_TYPE_OPTIONS = {
  DISABLE: 'DISABLE',
  ENABLE: 'ENABLE',
  ENABLE_AND_MANDATORY_ALLOW_EDIT: 'ENABLE_AND_MANDATORY_ALLOW_EDIT',
  ENABLE_AND_MANDATORY_FORBID_EDIT: 'ENABLE_AND_MANDATORY_FORBID_EDIT',
  ENABLE_BUT_OPTIONAL: 'ENABLE_BUT_OPTIONAL',
};

export const CARD_PRICE_TYPE = {
  NIGHTLY: 'NIGHTLY',
  MONTHLY: 'MONTHLY',
};

export const SET_UP_RATE_TYPE_OPTION_VALUE_OPTION = {
  NIGHTLY: 'NIGHTLY',
  MONTHLY: 'MONTHLY',
  NIGHTLY_AND_MONTHLY: 'NIGHTLY_AND_MONTHLY',
  TOTAL_PRICE: 'TOTAL_PRICE',
  RENT_ONLY: 'RENT_ONLY',
};

export const APPROVAL_TEMPLATE_TYPE_OPTIONS = {
  ONLINE_REFUND: 'ONLINE_REFUND',
  OFFLINE_REFUND: 'OFFLINE_REFUND',
  REFUND_ONLINE_PAYMENT_OFFLINE: 'REFUND_ONLINE_PAYMENT_OFFLINE',
  BOOKING_CURATION: 'BOOKING_CURATION',
};

export const NEED_APPROVAL_OPTIONS = {
  YES: 'YES',
  NO: 'NO',
  NOT_SET: 'NOT_SET',
};

export const APPROVAL_TYPE_OPTIONS = {
  FINANCE: 'FINANCE',
  BOOKING: 'BOOKING',
};

export const FINANCE_STATUS_OPTIONAL_VALUE = {
  SEVEN_DAY_LETTER: 'SEVEN_DAY_LETTER',
  FOURTEEN_DAY_LETTER: 'FOURTEEN_DAY_LETTER',
  TWENTYONE_DAY_LETTER: 'TWENTYONE_DAY_LETTER',
  LETTER_BEFORE_ACTION: 'LETTER_BEFORE_ACTION',
  WITH_LEGAL: 'WITH_LEGAL',
  INCORRECT_ARREARS: 'INCORRECT_ARREARS',
  PENDING_BANK_TRANSFER: 'PENDING_BANK_TRANSFER',
  IRRECOVERABLE_DEBT: 'IRRECOVERABLE_DEBT',
  TENANCY_REGULATION_BOARD: 'TENANCY_REGULATION_BOARD',
  OFFLINE_PAYMENT_PLAN: 'OFFLINE_PAYMENT_PLAN',
};

export const CONTRACT_TAG_OPTIONAL_VALUE = {
  CONTRACT_SENT: 'CONTRACT_SENT',
  CONTRACT_SIGNED: 'CONTRACT_SIGNED',
};

// For booking list filter
export const CONTRACT_TAG_OPTIONAL_VALUE_WITH_NONE = {
  CONTRACT_SENT: 'CONTRACT_SENT',
  CONTRACT_SIGNED: 'CONTRACT_SIGNED',
  NONE: 'NONE',
};

export const CHARGING_END_DATE_BEHAVIOR_TYPE_OPTION = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
};

export const CHARGING_END_DATE_POINT_TYPE_OPTION = {
  CONTRACT_END_DATE: 'CONTRACT_END_DATE',
};

export const APPROVAL_STATUS = {
  INIT: 'INIT',
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHANGE_REQUESTED: 'CHANGE_REQUESTED',
  IN_REVIEW: 'IN_REVIEW',
};

export const APPROVAL_TICKET_TYPE = {
  ONLINE_REFUND: 'ONLINE_REFUND',
  OFFLINE_REFUND: 'OFFLINE_REFUND',
  REFUND_ONLINE_PAYMENT_OFFLINE: 'REFUND_ONLINE_PAYMENT_OFFLINE',
  BOOKING_CURATION: 'BOOKING_CURATION',
};

export const REFUND_STAUS = {
  SCHEDULED: 'SCHEDULED',
  INITIATED: 'INITIATED',
  PENDING: 'PENDING',
  REQUIRES_ACTION: 'REQUIRES_ACTION',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  PENDING_AFTER_APPROVAL: 'PENDING_AFTER_APPROVAL',
};

export const REBOOKER_TAG_OPTIONAL_VALUE = {
  YES: 'YES',
  NO: 'NO',
};

export const GUEST_TYPE_OPTIONS = {
  GUEST: 'GUEST',
  OCCUPANT: 'OCCUPANT',
};

export const MODEL_OPTIONS = {
  BOOKING: 'BOOKING',
  STUDENT: 'STUDENT',
  EMERGENCY_CONTACT: 'EMERGENCY_CONTACT',
  GUARANTOR_CONTACT: 'GUARANTOR_CONTACT',
};

export const FIELD_FORMAT_OPTIONS = {
  SHORT_TEXT: 'SHORT_TEXT',
  PICKLIST: 'PICKLIST',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
};

export const BANK_ACCOUNT_COUNTRY_OPTIONS = {
  EXCEPT: 'EXCEPT',
  INCLUDE: 'INCLUDE',
};

export const TRANSACTION_FEE_RATE_TYPE_OPTIONS = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  COMBINATION: 'COMBINATION',
};

export const CARD_TYPE_OPTIONS = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  PREPAID: 'PREPAID',
};

export const CARD_COUNTRY_TYPE_OPTIONS = {
  DOMESTIC: 'DOMESTIC',
  INTERNALTION: 'INTERNALTION',
  NOT_SPECIFIC: 'NOT_SPECIFIC',
};

export const GUEST_RELATIONSHIP_OPTIONS = {
  PARENTS: 'PARENTS',
  RELATIVES: 'RELATIVES',
  FRIENDS: 'FRIENDS',
  CLASSMATES: 'CLASSMATES',
  OTHERS: 'OTHERS',
};

export const ANNOUNCEMENT_RESTRICTION_OPTIONS = {
  BOOKING_STATUS: 'BOOKING_STATUS',
  BOOKING_TYPE: 'BOOKING_TYPE',
  ROOM_TYPE: 'ROOM_TYPE',
  TENANCY_OPTION: 'TENANCY_OPTION',
  ACADEMIC_YEAR: 'ACADEMIC_YEAR',
  FLOOR: 'FLOOR',
  BUILDING: 'BUILDING',
  REBOOKER_TAG: 'REBOOKER_TAG',
  REBOOKER_TRANSFER_TAG: 'REBOOKER_TRANSFER_TAG',
  ARREARS_TAG: 'ARREARS_TAG',
  ALERTS: 'ALERTS',
};

export const TEMPLATE_STATUS_OPTION = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
  UNPUBLISHED: 'UNPUBLISHED',
  DELETED: 'DELETED',
  SCHEDULED: 'SCHEDULED',
};

export const PARCEL_SENDER_OPTIONS = {
  ALIEXPRESS: 'ALIEXPRESS',
  AMAZON: 'AMAZON',
  ANPOST: 'ANPOST',
  ASOS: 'ASOS',
  AURO: 'AURO',
  CARREFOUR: 'CARREFOUR',
  COLISSIMO: 'COLISSIMO',
  CORREOS: 'CORREOS',
  CTTEXPRESS: 'CTTEXPRESS',
  DHL: 'DHL',
  DPD: 'DPD',
  ECOSHOOTING: 'ECOSHOOTING',
  EROSKI: 'EROSKI',
  EVRI: 'EVRI',
  FASTWAY: 'FASTWAY',
  FEDEX: 'FEDEX',
  GLS: 'GLS',
  HERMES: 'HERMES',
  KPARCEL: 'KPARCEL',
  LADESPENSA: 'LADESPENSA',
  LOVESPACE: 'LOVESPACE',
  MERCADONA: 'MERCADONA',
  MIRAVIA: 'MIRAVIA',
  MRW: 'MRW',
  NACEX: 'NACEX',
  PAACK: 'PAACK',
  PARCELFORCE: 'PARCELFORCE',
  ROYALMAIL: 'ROYALMAIL',
  SENDING: 'SENDING',
  SEUR: 'SEUR',
  SHEIN: 'SHEIN',
  TEMU: 'TEMU',
  TIPSA: 'TIPSA',
  UPS: 'UPS',
  XPO: 'XPO',
  YODEL: 'YODEL',
  ZALANDO: 'ZALANDO',
  OTHERS: 'OTHERS',
};

export const PARCEL_SIZE_OPTIONS = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};

export const PARCEL_TYPE_OPTIONS = {
  CARTON: 'CARTON',
  PACKAGE: 'PACKAGE',
  LETTER: 'LETTER',
  OTHERS: 'OTHERS',
};

export const PARCEL_STATUS_OPTIONS = {
  TO_COLLECT: 'TO_COLLECT',
  COLLECTED: 'COLLECTED',
  CANCELLED: 'CANCELLED',
};

export const TICKET_CATEGORY_OPTIONS = {
  APPLIANCES: 'APPLIANCES',
  CLEANING: 'CLEANING',
  PLUMBING_LEAKING: 'PLUMBING_LEAKING',
  HEATING_A_C: 'HEATING_A_C',
  LIGHTING: 'LIGHTING',
  WINDOWS_DOORS: 'WINDOWS_DOORS',
  FURNITURE_FITTING: 'FURNITURE_FITTING',
  FLOORING: 'FLOORING',
  GENERAL: 'GENERAL',
  OTHER: 'OTHER',
};

export const ACCOUNT_MODEL_OPTIONS = {
  STAFF: 'STAFF',
  RESIDENT: 'RESIDENT',
};

export const PRIORITY_OPTIONS = {
  C1_1_HOUR: 'C1_1_HOUR',
  C2_24_HOURS: 'C2_24_HOURS',
  C3_7_DAYS: 'C3_7_DAYS',
  C3_28_DAYS: 'C3_28_DAYS',
};

export const SENDER_TYPE = {
  STAFF: 'STAFF',
  STUDENT: 'STUDENT',
};

export const TICKET_MESSAGE_TYPE = {
  TEXT: 'TEXT',
  FILE: 'FILE',
};

export const TICKET_TYPE_OPTIONS = {
  MAINTENANCE: 'MAINTENANCE',
  ENQUIRY: 'ENQUIRY',
  MESSAGE: 'MESSAGE',
  TASK: 'TASK',
};

export const EVENT_TIME_TYPE_OPTIONS = {
  SPECIFIC_TIME: 'SPECIFIC_TIME',
  ALL_DAY: 'ALL_DAY',
};

export const EVENT_STATUS_OPTIONS = {
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
  CANCELLED: 'CANCELLED',
};

export const EVENT_BOOKABLE_NUMBER_LIMIT_TYPE_OPTIONS = {
  UNLIMITED: 'UNLIMITED',
  LIMITED: 'LIMITED',
};

export const REGISTRATION_STUDENT_STATUS_OPTIONS = {
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
};

export const TICKET_STATUS_OPTIONS = {
  UNASSIGNED: 'UNASSIGNED',
  NOT_STARTED: 'NOT_STARTED',
  IN_PROCESS: 'IN_PROCESS',
  COMPLETED: 'COMPLETED',
};

export const CUSTOM_FIELD_MODEL_TYPE_OPTIONS = {
  BOOKING: 'BOOKING',
  STUDENT: 'STUDENT',
  GUARANTOR_CONTACT: 'GUARANTOR_CONTACT',
  EMERGENCY_CONTACT: 'EMERGENCY_CONTACT',
};

export const CALCULATION_TYPE_OPTIONS = {
  DYNAMIC_CALCULATION: 'DYNAMIC_CALCULATION',
  STATIC_CALCULATION: 'STATIC_CALCULATION',
};

export const TASK_PACK_STATUS_OPTIONS = {
  VALIDATING: 'VALIDATING',
  VALIDATED: 'VALIDATED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  IMPORTING: 'IMPORTING',
  IMPORTED: 'IMPORTED',
  IMPORT_FAILED: 'IMPORT_FAILED',
  ALLOCATING: 'ALLOCATING',
  ALLOCATED: 'ALLOCATED',
  ALLOCATION_FAILED: 'ALLOCATION_FAILED',
  CLOSED: 'CLOSED',
};

export const TASK_PACK_BOOKING_CATEGORY_OPTIONS = {
  DIRECT_LET: 'DIRECT_LET',
  CAMPAIGN: 'CAMPAIGN',
};

export const MIGRATE_BOOKINGS_PRIMARY_KEY_OPTIONS = {
  LEGACY_BOOKING_ID: 'LEGACY_BOOKING_ID',
  SELF_BUILD_BOOKING_ID: 'SELF_BUILD_BOOKING_ID',
};

export const EMAIL_THEME_OPTIONS = {
  BOOKING_RELATED: 'BOOKING_RELATED',
  FINANCE: 'FINANCE',
  AUTOMATIC_CARD_PAYMENT: 'AUTOMATIC_CARD_PAYMENT',
  DIRECT_DEBIT_GENERAL: 'DIRECT_DEBIT_GENERAL',
  BANK_TRANSFER: 'BANK_TRANSFER',
};

export const EMAIL_TRIGGER_NAME_OPTIONS = {
  OFFER_BOOKING_FROM_GIBBS: 'OFFER_BOOKING_FROM_GIBBS',
  HOLDING_BED_FROM_GIBBS: 'HOLDING_BED_FROM_GIBBS',
  MARKETING_EMAIL_FOR_BOOKING_CREATED_FROM_SP: 'MARKETING_EMAIL_FOR_BOOKING_CREATED_FROM_SP',
  CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED: 'CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED',
  WELCOME_EMAIL_FOR_CHECK_IN: 'WELCOME_EMAIL_FOR_CHECK_IN',
  CONFIRMATION_EMAIL_FOR_CHECK_OUT: 'CONFIRMATION_EMAIL_FOR_CHECK_OUT',
  REMINDER_EMAIL_FOR_BOOKING_EXPIRED: 'REMINDER_EMAIL_FOR_BOOKING_EXPIRED',
  GUIDE_EMAIL_BEFORE_CHECK_OUT: 'GUIDE_EMAIL_BEFORE_CHECK_OUT',
  FLEXIBLE_SETTING_GUIDE_EMAIL_BEFORE_CHECK_OUT: 'FLEXIBLE_SETTING_GUIDE_EMAIL_BEFORE_CHECK_OUT',
  CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED_GUARANTOR:
    'CONFIRMATION_EMAIL_FOR_BOOKING_CONFIRMED_GUARANTOR',
  CANCELLATION_AFTER_CHECK_IN: 'CANCELLATION_AFTER_CHECK_IN',
  BOOKING_CANCELLED: 'BOOKING_CANCELLED',
  AMENDMENT_PENDING: 'AMENDMENT_PENDING',
  AMENDMENT_EXPIRED: 'AMENDMENT_EXPIRED',
  AMENDMENT_CONFIRMED: 'AMENDMENT_CONFIRMED',
  APP_ONBOARDING: 'APP_ONBOARDING',
  STUDENT_CHECK_IN_TASK_REMINDED: 'STUDENT_CHECK_IN_TASK_REMINDED',
  IGNORE_AGE_RESTRICTION: 'IGNORE_AGE_RESTRICTION',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_STATUS_CHANGES: 'PAYMENT_STATUS_CHANGES',
  REMINDER_PAYMENT_DUE_APPROACHING: 'REMINDER_PAYMENT_DUE_APPROACHING',
  REMINDER_PAYMENT_OVERDUE: 'REMINDER_PAYMENT_OVERDUE',
  REMINDER_DIRECT_DEBIT_INIT: 'REMINDER_DIRECT_DEBIT_INIT',
  BACS_DIRECT_DEBIT_BIND_WITH_PAYMENT: 'BACS_DIRECT_DEBIT_BIND_WITH_PAYMENT',
  CARD_TIED: 'CARD_TIED',
  DIRECT_DEBIT_FAILED: 'DIRECT_DEBIT_FAILED',
  DIRECT_DEBIT_PAYMENT_INIT: 'DIRECT_DEBIT_PAYMENT_INIT',
  DIRECT_DEBIT_SUCCESS: 'DIRECT_DEBIT_SUCCESS',
  DIRECT_DEBIT_SETUP_ON_BOOKING: 'DIRECT_DEBIT_SETUP_ON_BOOKING',
  DIRECT_DEBIT_DISABLE_ON_BOOKING: 'DIRECT_DEBIT_DISABLE_ON_BOOKING',
  DIRECT_DEBIT_DISABLE_ON_PROPERTY: 'DIRECT_DEBIT_DISABLE_ON_PROPERTY',
  CARD_REMOVED_FROM_BOOKING: 'CARD_REMOVED_FROM_BOOKING',
  DIRECT_DEBIT_DISPUTE: 'DIRECT_DEBIT_DISPUTE',
  AUTO_PAYMENT_FAILED: 'AUTO_PAYMENT_FAILED',
  RECEIPT_FOR_PAYMENT_ITEMS: 'RECEIPT_FOR_PAYMENT_ITEMS',
  DOCUMENT_MISSING_REMINDER: 'DOCUMENT_MISSING_REMINDER',
  BANK_TRANSFER_INIT: 'BANK_TRANSFER_INIT',
  BANK_TRANSFER_FUTURE_INIT: 'BANK_TRANSFER_FUTURE_INIT',
  BANK_TRANSFER_CANCELLED: 'BANK_TRANSFER_CANCELLED',
  BANK_TRANSFER_FUTURE_CANCELLED: 'BANK_TRANSFER_FUTURE_CANCELLED',
  BANK_TRANSFER_UNDERPAYMENT: 'BANK_TRANSFER_UNDERPAYMENT',
  BANK_TRANSFER_FUTURE_UNDERPAYMENT: 'BANK_TRANSFER_FUTURE_UNDERPAYMENT',
  TAKEOVER_PENDING: 'TAKEOVER_PENDING',
  TAKEOVER_CONFIRMED: 'TAKEOVER_CONFIRMED',
  TAKEOVER_EXPIRED: 'TAKEOVER_EXPIRED',
  SET_ACCOUNT: 'SET_ACCOUNT',
  STUDENT_ASK_BANK_ACCOUNT: 'STUDENT_ASK_BANK_ACCOUNT',
  STUDENT_NOTIFY_FINANCE_PROGRESS: 'STUDENT_NOTIFY_FINANCE_PROGRESS',
  CURATION_TICKET_APPROVED: 'CURATION_TICKET_APPROVED',
  CURATION_TICKET_REJECTED: 'CURATION_TICKET_REJECTED',
  APPROVE_AMENDMENT_APPLICATION: 'APPROVE_AMENDMENT_APPLICATION',
};

export const TRIGGER_TO_RESERVE_BED_OPTIONS = {
  AFTER_MANUAL_REVIEW_COMPLETED: 'AFTER_MANUAL_REVIEW_COMPLETED',
  AFTER_SELECTION_COMPLETED: 'AFTER_SELECTION_COMPLETED',
};

export const GUARANTOR_TYPE_OPTIONS = {
  ONE_PERSONAL_GUARANTOR: 'ONE_PERSONAL_GUARANTOR',
  TWO_PERSONAL_GUARANTORS: 'TWO_PERSONAL_GUARANTORS',
  THIRD_PARTY_GUARANTOR: 'THIRD_PARTY_GUARANTOR',
  NO_GUARANTOR_REQUIRED: 'NO_GUARANTOR_REQUIRED',
};

export const COUNTRY_SELECT_OPTIONS = {
  ALL: 'ALL',
  SPECIFIC_COUNTRIES: 'SPECIFIC_COUNTRIES',
};

export const DOCUMENT_SETTING_STAGE_OPTION = {
  BEFORE_BOOKING_CONFIRMATION: 'BEFORE_BOOKING_CONFIRMATION',
  AFTER_BOOKING_CONFIRMATION: 'AFTER_BOOKING_CONFIRMATION',
};

export const DOCUMENT_SETTING_UPLOAD_STAGE_OPTIONS = {
  BEFORE_BOOKING_CONFIRMATION: 'BEFORE_BOOKING_CONFIRMATION',
  AFTER_BOOKING_CONFIRMATION: 'AFTER_BOOKING_CONFIRMATION',
};

export const INVOICE_GENERATION_TYPE_OPTIONS = {
  ONE_INVOICE_FOR_ALL_BOOKINGS: 'ONE_INVOICE_FOR_ALL_BOOKINGS',
  ONE_INVOICE_PER_BOOKING: 'ONE_INVOICE_PER_BOOKING',
};

export const INVOICE_FREQUENCY_OPTIONS = {
  MONTHLY: 'MONTHLY',
};
